import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { useLang } from "../lib/i18n";

export const Positioning = ({ onNavigate }) => {
  const { t } = useLang();
  return (
    <section data-testid="positioning-banner" className="bg-gold py-24 md:py-32 relative overflow-hidden grain">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.9, ease: "easeOut" }}
          className="max-w-4xl">
          <p className="text-ink/60 text-[11px] tracking-mega uppercase mb-6">{t("pos.eyebrow")}</p>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-ink leading-tight">
            {t("pos.titleA")}<br />
            <span className="italic">{t("pos.titleB")}</span>
          </h2>
          <p className="mt-8 text-ink/75 text-sm md:text-base leading-relaxed max-w-2xl">
            {t("pos.body")}
          </p>
          <button data-testid="positioning-cta" onClick={() => onNavigate("contact")}
            className="group mt-10 inline-flex items-center gap-3 bg-ink text-cream text-xs tracking-[0.2em] uppercase px-8 py-4 hover:bg-green transition-colors duration-300">
            {t("pos.cta")}
            <ArrowUpRight size={14} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 rtl:-scale-x-100" />
          </button>
        </motion.div>
      </div>
      <span aria-hidden="true" className="absolute -right-10 -bottom-24 font-display text-[26rem] leading-none text-ink/5 select-none pointer-events-none">A</span>
    </section>
  );
};
